# I think this is deprecated now (in favor of Layer_Shapefile_GeoJSON)
#
class exports.Layer_Shapefile_Polygon extends Handler
    constructor: () ->
        super()
        @layoutSelector = null


    init: () ->
        id = @loadLayoutPostOptions.id

        @overlay = new geoXML3.parser
            map: App.map
            processStyles: true
            singleInfoWindow: true
            infoWindowOptions:
                disableAutoPan: true
            afterParse: (doc) ->

                for p in doc[0]['gpolygons']
                    p['fillOpacity'] = 0.65

        @overlay.parse "layers/shapefile/get-kml?id=#{id}"


    destroy: () ->
        if @overlay
            @overlay.hideDocument()

